// Autogenerated by sprite compiler (large sprites)

export interface ILargeSprite {
  k: string
  d: string
  f: string
}

export const largeSprites = {
  chessBoard: { k: 'chessBoard', d:'goat/chess', f:'chess-board' },
  eeriePathFull: { k: 'eeriePathFull', d:'goat/chess_bg', f:'Eerie_Path_Full' },
  hiddenTempleFull: { k: 'hiddenTempleFull', d:'goat/chess_bg', f:'Hidden_Temple_Full' },
  quietMonasteryFull: { k: 'quietMonasteryFull', d:'goat/chess_bg', f:'Quiet_Monastery_Full' },
  redFortressFull: { k: 'redFortressFull', d:'goat/chess_bg', f:'Red_Fortress_Full' },
  riverCastleFull: { k: 'riverCastleFull', d:'goat/chess_bg', f:'River_Castle_Full' },
  untilYourKingIsDeadLogo2: { k: 'untilYourKingIsDeadLogo2', d:'goat/chess', f:'until-your-king-is-dead-logo-2' },
}

